export default __webpack_public_path__ + "static/media/bubble_2.893858b3.png";